var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9443 4.52295V21.3394C30.9443 23.3901 29.2451 25.0308 27.1943 25.0308H18.7568L11.4326 30.48C10.9639 30.8315 10.3193 30.5386 10.3193 29.9526V25.0308H4.69434C2.58496 25.0308 0.944336 23.3315 0.944336 21.3394V4.52295C0.944336 2.41357 2.58496 0.772949 4.69434 0.772949H27.1943C29.3037 0.772949 30.9443 2.47217 30.9443 4.52295Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSolid);
export default __webpack_public_path__ + "static/media/message-solid.daf905052af23055b5c32ece5767ed95.svg";
export { ForwardRef as ReactComponent };